import { type TextareaHTMLAttributes, forwardRef } from 'react';

import { classNames } from './classNames';

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, invalid = false, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={classNames(
        'hotam-field',
        'hotam-textarea',
        invalid && 'hotam-field--invalid',
        className,
      )}
      {...props}
    />
  ),
);

TextArea.displayName = 'TextArea';
